<template>
  <div class="invite-table" :style="{ height: tableData.options.tableHeight + 'px' }">
    <el-table
      :data="tableData.list"
      border
      fit
      :max-height="tableData.options.tableHeight"
      style="width: 100%"
    >
      <!-- 暂无数据提示，自己定义就OK了 -->
      <template slot="empty">
        <div class="empty-box mt20 mb20">
          <div style="height: 100%; padding: 100px 0">
            <i class="mh-kym_icon icon"></i>
            <p class="col-66 text-1 mt10">
              {{
                tableData.options.errortip != ""
                  ? tableData.options.errortip
                  : "暂无数据"
              }}
            </p>
          </div>
        </div>
      </template>

      <!-- 表格数据渲染 -->
      <template v-for="(column, $index) in tableData.columns">
        <el-table-column
          :prop="column.fieldstring"
          :key="$index"
          fixed="left"
          :label="column.fieldname"
          align="center"
          min-width="120px"
          className="v-align-t"
        >
          <template slot-scope="scope">
            <div type="text" class="invite-item">
              <span
                class="invite-day"
                :style="{
                  color:
                    tableData.list[scope.$index][column.fieldstring]
                      .is_this_month == 1
                      ? '#333333'
                      : '#c5c5c5',
                }"
              >
                {{ tableData.list[scope.$index][column.fieldstring].day }}</span
              >
              <div
                class="class-list"
                v-if="tableData.list[scope.$index][column.fieldstring].info"
              >
                <div
                  v-for="(item, classIdx) in tableData.list[scope.$index][
                    column.fieldstring
                  ].info.slice(0, 4)"
                  :key="classIdx"
                  :class="{
                    'bg-green': item.course_inclasstype != '3',
                    'bg-yellow':
                      item.course_inclasstype == '3' &&
                      item.course_openclasstype == '1',
                    'bg-blue':
                      item.course_inclasstype == '3' &&
                      item.course_openclasstype == '0',
                  }"
                  @click="onClickItem(item)"
                >
                  <div class="flex" style="justify-content: space-between">
                    <span
                      >{{ item.hour_starttime }}-{{ item.hour_endtime }}</span
                    >
                    <span v-if="item.class_appointnum == 0">不限</span>
                    <span v-else
                      >{{ item.bookingNum }}/{{ item.class_appointnum }}</span
                    >
                  </div>
                  <span
                    >{{ item.coursecat_branch }} {{ item.class_cnname }}</span
                  >
                </div>
              </div>
              <span
                @click="
                  onClickOther(tableData.list[scope.$index][column.fieldstring])
                "
                class="invite-other"
                v-if="
                  tableData.list[scope.$index][column.fieldstring].info.length >
                  4
                "
                >另外{{
                  tableData.list[scope.$index][column.fieldstring].info.length -
                  4
                }}个</span
              >
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-dialog
      class="invite-dialog"
      :title="currentDate"
      :visible.sync="dialogVisible"
      width="435px"
    >
      <div class="class-list">
        <div
          v-for="(item, classIdx) in classData"
          :key="classIdx"
          :class="{
            'bg-green': item.course_inclasstype != '3',
            'bg-yellow':
              item.course_inclasstype == '3' &&
              item.course_openclasstype == '1',
            'bg-blue':
              item.course_inclasstype == '3' &&
              item.course_openclasstype == '0',
          }"
          @click="onClickItem(item)"
        >
          <div class="flex" style="justify-content: space-between">
            <span>{{ item.hour_starttime }}-{{ item.hour_endtime }}</span>
            <span v-if="item.class_appointnum == 0">不限</span>
            <span v-else
              >{{ item.bookingNum }}/{{ item.class_appointnum }}</span
            >
          </div>
          <span>{{ item.coursecat_branch }} {{ item.class_cnname }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "noBorderTableCont",
  props: {
    // 表格数据所有参数
    tableData: {
      type: Object,
    },
  },
  data() {
    return {
      classData: [],
      dialogVisible: false,
      currentDate: "",
    };
  },
  methods: {
    // 表格内容绑定事件
    onClickItem(item) {
      (() => {})(item);
      this.$emit("onClickItem", item);
    },
    onClickOther(classItem) {
      this.classData = classItem.info;
      this.currentDate = classItem.month;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.invite-table {
  /deep/.el-table .v-align-t {
    vertical-align: top;
  }
  .invite-dialog {
    /deep/.el-dialog__header {
      font-size: 14px;
      font-weight: 600;
      color: #00000a;
    }
    /deep/.el-dialog__body {
      border: none !important;
    }
  }
  padding: 4px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  .invite-item {
    height: 100%;
    .invite-day {
      display: inline-block;
      width: 100%;
      font-size: 13px;
      text-align: end;
    }

    .invite-other {
      display: inline-block;
      width: 100%;
      color: #20a8d8;
      font-size: 12px;
      text-align: start;
      cursor: pointer;
      margin: 8px 0 0 8px;
    }
  }
  .class-list {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    > div {
      flex-shrink: 0;
      width: 100%;
      border-radius: 3px;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      padding: 6px 10px;
      margin-top: 7px;
      cursor: pointer;
      > span {
        text-align: start;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .bg-green {
      background: #44d298;
    }
    .bg-blue {
      background: #00a7d5;
    }
    .bg-yellow {
      background: #ffcb37;
    }
  }
}
</style>

